module.exports = __webpack_public_path__ + "img/bg_3.c9a2822f.jpg";